export enum Routes {
  Register = '/register',
  Search = '/search',
  Backoffice = '/backoffice',
  Home = '/home',
  Homes = '/homes',
  Experiences = '/experiences',
  // TODO: Change route search to route hotel on the entire site
  ThreeDS = '/three-ds',
  Error = '/error',
  BasicError = '/error/generic',
  CustomError = '/error/message',
  NotAuthorized = '/error/not-authorized',
  NotFound = '/error/404',
  Cruises = '/cruise',
  Cars = '/car',
  Dashboard = '/dashboard-wrapper',
  Getaway = '/getaway',
  Getaways = '/getaways',
  GetawayCondo = '/getaway/condo',
  GetawayCondos = '/getaway/condos',
  GetawayList = '/getaway/list',
  GetawayDetails = '/getaway/details',
  GetawayBookingPage = '/getaway-booking',
  SearchResult = '/result',
  Hotel = '/hotel',
  AllInclusive = '/all-inclusives',
  AllInclusivesSubmitRequest = '/all-inclusives/submit-request',
  Book = '/book',
  Condo = '/condo',
  CondosMap = '/condos/world-map',
  CondosWeeks = '/condos/weeks',
  Widget = '/widget',
  SearchHotelWidget = '/widget/search/hotel',

  CarsDashboard = '/cars',
  CondosDashboard = '/condos',
  CarsSearch = '/cars/search',
  CarsDetails = '/cars/details',
  CarsBook = '/cars/book',

  InsuranceQuote = '/insurance',

  WeeksSearch = '/weeks/search',
  WeeksDetails = '/weeks/details',
  WeeksBook = '/weeks/book',

  CondoSearch = '/condo/deals',
  UnitBook = '/unit-book',
  Loginv2 = '/log-in',
  ResetPasswordv2 = '/reset-password',
  Login = '/signin',
  Logout = '/signout',
  SignUp = '/signup',
  VerifyUser = '/verify',
  SendVerifyEmail = '/send-verify',
  ForgotPassword = '/password/forgot',
  ResetPassword = '/password/reset',
  ChangePassword = '/password/change',
  RequestCancelReservation = '/request-cancel-reservation',
  ReservationCancellation = '/reservation-cancellation',
  AmericanLifestyle = '/magazine',
  ConciergeTeam = '/concierge-travel-team',
  MemberStories = '/member/stories',
  Resources = '/travel-resources',
  DailyBenefits = '/daily-benefits',
  MemberVideos = '/member/videos',
  ContactUs = '/contact-us',
  MasterClassesRegister = '/master-classes-register',
  PersonalInfo = '/personal-info',
  Security = '/security',
  PromotionDetails = '/promotion',
  PrivacyPolicy = '/privacy-policy',
  PriceMatch = '/price-match',
  BrioRci = '/brio-rci',
  BrioRciHowTo = '/brio-rci/how-to',
  NewMembers = '/newmembers',
  EliteRciHowTo = '/elite-rci/how-to',
  Webinars = '/webinars',
  Faq = '/faq',
  Reservations = '/reservations',
  RsiAccount = '/account',
  AccountReservations = '/account/reservations',
  RsiTestDriveManager = '/account/test-drive-manage',
  RsiQuotes = '/account/quotes',
  SidekickRewards = '/sidekick-rewards',
  SidekickRewardsTerms = '/sidekick-rewards/terms',
  SidekickRewardsPrivacy = '/sidekick-rewards/privacy',

  MLMBecomeAgent = '/become-agent',
  MLMNewAgents = '/new-agents',
  MLMExperiencedAgents = '/experienced-agents',
  MLMExclusiveAccess = '/exclusive-access',
  MLMTraining = '/training',
  MLMTechnology = '/technology',
  HotelDashboard = "/dashboard",
  NotificationList = '/notifications-list',
}

export enum Urls {
  Users = '/users',
  UsersCards = '/users/paymentmethod',
  CompanyCards = '/account/paymentmethod',
  SSO = '/sso',
  Accounts = '/account',
  Hotels = '/Hotels/search/page',
  Locations = '/Locations',

  CarsLocations = '/cars/locations',
  CarsSearch = '/cars/search',
  CarsDetails = '/cars/recheck',
  CarsCheckout = '/cars/checkout',
  CarsCheckoutResume = '/cars/book-resume',

  NavigationItems = '/account/menu',
  Suppliers = '/suppliers',
  HotelDetails = '/hotels/hotel',
  BookingSummary = '/hotels/hotel/booking-summary',
  BookPackageWithCard = '/hotels/book-package-with-card',
  BookPackageWithCardResume = '/hotels/book-resume',
  BookResumeExpress = '/hotels/book-resume-express',
  CarsResumeExpress = '/cars/book-express-resume',
  HotelsMap = '/hotels/search/area',
  HotelRedeemCode = '/hotels/redeem-code',
  HotelRemoveCode = '/hotels/cancel-redeem-code',
  HotelAutocomplete = '/hotels/hotel/autocomplete',
  reservationCancellationDetails = '/bookings/reservation-details',
  cancelReservation = '/bookings/cancel-reservation',
  requestCancelReservation = '/bookings/request-cancel',
  HotelsRecentSearches = '/hotels/recent-searches',
  HotelTopDeals = '/hotels/top-deals',
  HotelRooms = '/hotels/search/id',

  WalletUser = '/wallet/byuserId',

  Quotes = '/deals/quote',
  MarketingWeeks = '/deals/prequote-availabity',

  getReservations = '/bookings/browsebookingbyuser',
  getCompanyBookings = '/bookings/bookings/CompanyBookings',
  getContentByPropertyId = '/bookings/content',
  reservationsSearchText = '/bookings/bookingsearch',
  companyBookingsSearchText = '/bookings/bookingsearch',
  reservationsCancel = '/bookings/cancel',
  reservationsSendVoucher = '/bookings/voucher',
  DownloadVoucher = '/bookings/bookings',
  DownloadMyBookings = '/bookings/bookings/browsebookingbyuser',
  QuotesHontelsDownload = '/bookings/quotes/download',
  QuotesHotelsShare = '/bookings/quotes/share',

  QuotesWeeksDownload = '/bookings/quotes/weeks/download',
  QuotesWeeksShare = '/bookings/quotes/weeks/share',

  QuotesCondosDownload = '/bookings/quotes/condo/download',
  QuotesCondosShare = '/bookings/quotes/condo/share',

  getTravelHistory = '/sso/browsetravelhistorybyuser',
  ssoMember = '/sso/member',

  GetHotels = '/api/hotels',

  TrustYou = 'https://api.trustyou.com/hotels',
  Deals = '/deals',
  Getaways = '/deals',
  GetawaysMLM = '/deals/geolocations',
  CurrentUser = '/sso/currentuser',
  Benefits = '/sso/benefits',

  Currencies = '/currencies',

  CondosRecommendedLocations = '/condos/locations/recommended',
  CondosRecentSearches = '/condos/recent-searches',
  CondosLocationsPopularDestinations = '/condos/locations/popular',
  CondosLocations = '/condos/locations',
  CondosSearchStrict = '/condos/search/strict',
  CondosSearchStrictPagination = '/condos/search/strict/page',
  CondosSearchFlexible = '/condos/search/flexible',
  CondosSearchFlexiblePagination = '/condos/search/flexible/page',
  CondosSearchAnytime = '/condos/search/anytime',
  CondosSearchAnytimePagination = '/condos/search/anytime/page',
  CondoDetails = '/condos/details',
  CondoBook = '/condos/book',
  CondoBookResume = '/condos/book-resume',
  CheckinStatus = '/condos/checkin-status',
  CondoUnits = '/condos/search/units',
  CondoCountries = '/condos/countries',
  CondoBookingSummary = '/condos/booking-summary',
  CondoAllDestinations = '/condos/locations/alldestinations',

  WeeksSearch = '/property/search/week/page',
  WeeksDetails = '/property/week/details',
  WeeksBookingSummary = '/property/booking-summary',
  WeeksBook = '/property/book',
  WeeksBookResume = '/property/book-resume',
  WeeksUnitSearch = '/property/search/units',

  AllInclusiveDestinations = '/locations/allinclusive',

  CondoRedeemCode = '/api/condos/redeem-code',
  CondoRemoveCode = '/api/condos/cancel-redeem-code',

  InsuranceGetQuote = '/insurance/quote',
  InsuranceCheckout = '/insurance/checkout',

  Magazine = '/external/magazine',
  NotificationBar = '/external/notification-bar',
  Notification = '/notifications/Notifications',
  NotificationList = '/notifications-list',
  ReadNotification = '/Notifications/Notifications/log',
  MarkAsReadNotification = '/Notifications/Notifications/log/updateAll',
  MemberStories = '/external/member-stories',

  Slides = '/external/slides',
  Promotions = '/promotions',
  MemberVideos = 'https://rsistaticdata.s3.amazonaws.com/membervideos',
  PersonalDetails = '/api/sso/personal-details',

  DashboardReports = '/bookings/reporttravelagenthome',
  TrendsReports = '/bookings/bookings/travbusiness/dashboard',

  FetchCountries = "/condos/countries",
  FetchUserAccount = "/identity/account/",
  SaveUserAccount = "/identity/account/save",
  GetTeamMembers = "/identity/users",
  GetDepartments = "/identity/account/get-department",
  GetDepartmentPreference = "/identity/account/get-department-preference",
  SaveDepartmentPreference = "/identity/account/save-department-preference",
  SaveDepartment = "/identity/account/save-department",
  GetUserRoles = "/identity/roles",
  HotelsSearch ="/Hotels/search/page",
  CustomFields = "/identity/account/custom-fields",
  DeleteDepartment = "/identity/account/delete-department",
  ACHPaymentDebit = "/payments/plaid/ACHPaymentDebit",
  GetPlaidACHPaymentList = "/payments/plaid/GetPlaidACHPaymentList",
  GetPlaidBankAccountList = "/payments/plaid/GetBankAccountList",
  PlaidCreateLinkToken = "/payments/plaid/CreateLinkToken",
  PlaidSaveBankDetail = "/payments/plaid/SaveBankDetail",
  getCreditLineInvoiceSummary = "/bookings/CreditLineInvoices/CreditLineInvoiceSummary",
  CreditLineInvoicesByPaidDate = "/bookings/CreditLineInvoices?orderBy=paidDate&sortOrder=desc&page=1&results=10",
  MergeLinktoken = "/identity/Merge/linktoken",
  MergeExchangePublicToken = "/identity/Merge/exchange-public-token",
  MergeLinkedAccounts = "/identity/Merge/linked-account-list",
  GetCompanyEmployees = "/identity/Merge/employee-list",
  ExportToExcel = "/bookings/bookings/travbusiness/dashboard",
  ExportToCSV = "/bookings/bookings/travbusiness/dashboard",
  ExportCreditLine = "/bookings/CreditLineInvoices/ExportCreditLine",
  GetPaymentPreference = "/identity/account/get-payment-preference-settings",
  SavePaymentPreference = "/identity/account/save-payment-preference-settings",
  GoogleLogin = '/identity/users/login-with-google',
  UploadUserProfilePicture = '/identity/users/upload-photo',
  SaveProfileInfo = '/identity/users/save-personal-info',
}
